import { environment } from 'src/environments/environment';
import { Observable } from "rxjs";
import { Router, ActivatedRouteSnapshot } from "@angular/router";
import { Injectable, inject } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class SingleProductModeGuardService  {
  private router = inject(Router);


  public canActivate(
    next: ActivatedRouteSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {

    const hostname = window.location.hostname;
    const subdomain = hostname.split('.')[0];
    if (environment.isSingleProductMode && subdomain === "shop") {
      setTimeout(() => {
        window.location.replace(environment.blogUrl);
      });
      return false;
    }
    return true;
  }
}
